import React from "react";

const ContainerBox = (props) => {
  const { className } = props;
  return <div className={className}>{props.children}</div>;
};

export default ContainerBox;
